import './helpButton.css'
import HelpButtom from '../../../assets/images/help-button.png' 

const HelpButton = (props)=> {



    return (<div className="help-container p-0">
        <a href={props.helpButton.toString()} target='_blank' rel='noreferrer'>
            <img  className='img img-fluid'  src={HelpButtom} alt="img" />    
        </a>
    </div>)
}

export default HelpButton;